
      import API from "!../../../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.106.2/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.106.2/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.106.2/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.106.2/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.106.2/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.106.2/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.106.2/node_modules/css-loader/dist/cjs.js!../../../../../../../../node_modules/.pnpm/less-loader@12.2.0_less@4.2.1_webpack@5.106.2/node_modules/less-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./codeSnippetBlock.less";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.106.2/node_modules/css-loader/dist/cjs.js!../../../../../../../../node_modules/.pnpm/less-loader@12.2.0_less@4.2.1_webpack@5.106.2/node_modules/less-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./codeSnippetBlock.less";
       export default content && content.locals ? content.locals : undefined;
